import { render } from "./FormularioTratamiento.vue?vue&type=template&id=f6ab79a6&scoped=true&ts=true"
import script from "./FormularioTratamiento.vue?vue&type=script&lang=ts"
export * from "./FormularioTratamiento.vue?vue&type=script&lang=ts"

import "./FormularioTratamiento.vue?vue&type=style&index=0&id=f6ab79a6&lang=scss"
import "./FormularioTratamiento.vue?vue&type=style&index=1&id=f6ab79a6&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ab79a6"]])

export default __exports__